import React from 'react';
import { useNavigate } from 'react-router-dom';
import ScrollFloat from './ScrollFloat';
import Threads from './Threads';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-threads">
        <Threads
          distance={0.4}
          enableMouseInteraction={false}
          color={[0.5, 0.7, 0.95]}
        />
      </div>
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            <ScrollFloat speed={0.3} direction="up">Your Company's</ScrollFloat>
            <br />
            <ScrollFloat speed={0.4} direction="up" className="gradient-text">
              Knowledge Assistant
            </ScrollFloat>
          </h1>
          <p className="hero-subtitle">
            <ScrollFloat speed={0.2} direction="up">
              Empower your employees with instant, accurate answers from your knowledge base. 
              Eliminate information gaps and accelerate training with our Microsoft Teams chatbot app.
            </ScrollFloat>
          </p>
          <div className="hero-badge">
            <span className="teams-badge">Chatbot App</span>
          </div>
          <div className="hero-cta">
            <button 
              className="btn-primary" 
              onClick={() => navigate('/contact')}
              aria-label="Schedule a demo to learn more about AIEx"
            >
              Schedule a Demo
            </button>
            <button 
              className="btn-secondary" 
              onClick={() => scrollToSection('features')}
              aria-label="Learn more about our features"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

